module.exports = __webpack_public_path__ + "img/map.c7e4a07f.svg";